import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { PaymentPlanDetailsPage } from '../../components/PaymentPlanDetails';
import { PaymentsPage } from '../../components/PaymentsPage';

export const PaymentPlanDetails = ({ paymentPlanId }: { paymentPlanId: string }) => {
  const { t } = useTranslation('payments');

  return (
    <PaymentsPage
      css={css`
        padding: ${theme.spacing(2)};
      `}
      breadcrumbs={[
        { label: t('Payment Plan List'), to: '/payments/payment-plans' },
        { label: t('Payment Plan Details') },
      ]}
    >
      <PaymentPlanDetailsPage paymentPlanId={paymentPlanId} />
    </PaymentsPage>
  );
};
